import React from 'react';
import CorporateServices from '../components/CorporateServices';

const CorporatePage = () => {
  return (
    <>
      <CorporateServices />
    </>
  );
};

export default CorporatePage;
